import { render, staticRenderFns } from "./FeaturesArtists.vue?vue&type=template&id=1ef14e17&scoped=true"
import script from "./FeaturesArtists.vue?vue&type=script&lang=js"
export * from "./FeaturesArtists.vue?vue&type=script&lang=js"
import style0 from "./FeaturesArtists.vue?vue&type=style&index=0&id=1ef14e17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef14e17",
  null
  
)

export default component.exports